/* eslint-disable consistent-return,no-underscore-dangle,@typescript-eslint/no-unused-vars,no-var */

import { DESIGNER_EVENTS } from '../../../../../app/constants/designer_events';

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerStage', [
    '$rootScope',
    '$window',
    '$timeout',
    'DesignerBase',

    function ($rootScope, $window, $timeout, DesignerBase) {
      function DesignerStage(designer) {
        this.designer = designer;
        this.element = null;
        this.x = 0;
        this.y = 0;
        this.scale = 1;
      }

      DesignerStage.prototype = new DesignerBase();

      DesignerStage.prototype.setElement = function (element) {
        const _this = this;
        this.element = element;
        this.$grid = element.find('.designer-grid-rect');
        this.$win = angular.element($window);
        $timeout(function () {
          _this.$grid.attr('style', `fill: url('${_this.absUrl()}#designer-grid')`);
        });
        this.initEvents();
      };

      DesignerStage.prototype.initEvents = function () {
        const _this = this;
        let moved = false;
        let selector;
        let $selector;
        let selectorStartX = 0;
        let selectorStartY = 0;

        const _types = {
          source: 'source',
          transformation: 'transformation',
          destination: 'destination',
          workflow: 'workflow',
        };

        const moveSelector = function (e) {
          let width = e.clientX - selectorStartX + _this.designer.scrollLeft;
          let height = e.clientY - selectorStartY + _this.designer.scrollTop;

          const x = width >= 0 ? selectorStartX : selectorStartX + width;
          const y = height >= 0 ? selectorStartY : selectorStartY + height;

          width = width >= 50 ? width - 50 : -width + 50;
          height = height >= 0 ? height : -height;

          width = width >= 50 ? width - 50 : -width + 50;
          height = height >= 0 ? height : -height;

          const topHeader = document.querySelector('.page-top-header');
          const topHeaderHeight = topHeader ? topHeader.offsetHeight : 0;

          const selectorPosition = {
            x,
            y: y - topHeaderHeight,
            width,
            height,
          };

          $selector.attr(selectorPosition);

          _this.designer.package.selectComponents(selectorPosition);

          moved = true;
        };

        const unselect = function () {
          if (!moved) _this.designer.package.unselectAllComponents();
          moved = false;
          $rootScope.$broadcast(DESIGNER_EVENTS.CONTEXT_MENU_HIDE);
        };

        var destroySelector = function () {
          _this.element[0].classList.remove('selecting');
          _this.element.off('mousemove', moveSelector);
          _this.$win.off('mouseup', destroySelector);
          _this.element.find('.designer-selector').remove();
          $selector = null;
        };

        const createSelector = function (e) {
          if ($selector !== null) destroySelector();

          if (angular.element(e.target).is(_this.$grid) && e.which === 1) {
            selector = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
            $selector = angular.element(selector);

            const gridOffset = { left: 50, top: 0 }; // _this.$grid.offset();

            selectorStartX = e.clientX - gridOffset.left + _this.designer.scrollLeft;
            selectorStartY = e.clientY - gridOffset.top + _this.designer.scrollTop;

            _this.element[0].appendChild(selector);
            _this.element[0].classList.add('selecting');

            selector.classList.add('designer-selector');
            _this.element.on('mousemove', moveSelector);

            return false;
          }
        };

        this.$grid.on('mousedown', createSelector);
        this.$grid.on('mouseup', destroySelector);
        this.$win.on('mouseup', destroySelector);
        this.$grid.on('click', unselect);

        $rootScope.$on(DESIGNER_EVENTS.PACKAGE_RESIZE, function () {
          _this.resizeGrid();
        });

        this.resizeGrid();
      };

      DesignerStage.prototype.resizeGrid = function () {
        this.$grid.attr('width', this.designer.package.width);
        this.$grid.attr('height', this.designer.package.height);
      };

      return DesignerStage;
    },
  ]);
})(window.angular);
